import { RumConfiguration } from "@picsart/datadog-rum";

const DEFAULT_INIT_PARAMS = {
  env: process.env.REACT_APP_DATADOG_ENV,
};

const DD_RUM_SDK_INITIALIZATION_PARAMETERS: Record<string, RumConfiguration> = {
  'create-and-home': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      service: 'create-and-home',
    },
    globalContext: {
      team: 'activation',
    },
  },
  'user-flows': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      service: 'user-flows',
    },
    globalContext: {
      team: 'activation',
    },
  },
  'paid-ua': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      sessionReplaySampleRate: 100,
      service: 'paid-ua',
    },
    globalContext: {
      team: 'activation',
    },
  },
  'miniapp-container-social': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      service: 'miniapp-container-social',
    },
    globalContext: {
      team: 'activation',
    },
  },
  'careers-front': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      service: 'careers-front',
    },
    globalContext: {
      team: 'web-xp',
    },
  },
  'legal-and-press-kit': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      service: 'legal-and-press-kit',
    },
    globalContext: {
      team: 'web-xp',
    },
  },
  'landings': {
    initParams: {
      ...DEFAULT_INIT_PARAMS,
      service: 'landings',
    },
    globalContext: {
      team: 'web-xp',
    },
  },
};

export default DD_RUM_SDK_INITIALIZATION_PARAMETERS;
